import React from 'react';
import { motion } from 'framer-motion';
import { Book, Settings, Droplet, AlertTriangle, Wrench, Zap, Gift, CheckSquare, FileText } from 'lucide-react';
const tomos = [{
  icon: Book,
  tomo: 'TOMO 1',
  title: 'Guía completa Motor 2T Pro',
  description: 'Todo sobre tu motor 2 tiempos',
  price: '$7.990'
}, {
  icon: Settings,
  tomo: 'TOMO 2',
  title: 'Tablas de carburación',
  description: 'Ajustes precisos para cada motor y clima',
  price: '$5.990'
}, {
  icon: Droplet,
  tomo: 'TOMO 3',
  title: 'Tabla mezcla aceite 2T',
  description: 'Proporciones exactas para máxima protección',
  price: '$4.990'
}, {
  icon: AlertTriangle,
  tomo: 'TOMO 4',
  title: 'Diagnóstico de fallas',
  description: 'Identificá y solucioná problemas rápido',
  price: '$6.990'
}, {
  icon: Wrench,
  tomo: 'TOMO 5',
  title: 'Puesta a punto paso a paso',
  description: 'Optimización completa desde cero',
  price: '$7.990'
}, {
  icon: Zap,
  tomo: 'TOMO 6',
  title: 'Sincronización de encendido',
  description: 'Máximo rendimiento con timing perfecto',
  price: '$5.990'
}];
const bonuses = [{
  icon: CheckSquare,
  title: 'Checklist imprimible',
  description: 'Para tener siempre a mano',
  price: '$3.990'
}, {
  icon: FileText,
  title: 'Guía rápida de fallas',
  description: 'Soluciones inmediatas',
  price: '$4.090'
}, {
  icon: Zap,
  title: 'Acceso inmediato',
  description: 'Descargá todo al instante',
  price: '$1.990'
}];
export function PackSection() {
  return <section className="w-full bg-motor-black py-14 px-4 sm:px-6 lg:px-8" data-id="element-92">
      <div className="max-w-6xl mx-auto" data-id="element-93">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-94">
          <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-motor-red uppercase mb-3 leading-tight" data-id="element-95">
            TODO LO QUE NECESITÁS EN UN SOLO PACK
          </h2>
          <p className="text-lg text-gray-400 font-montserrat" data-id="element-96">
            6 tomos completos • Valor total por separado:{' '}
            <span className="text-white font-bold line-through" data-id="element-97">$39.990</span>
          </p>
        </motion.div>

        {/* Tomos Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14" data-id="element-98">
          {tomos.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} whileHover={{
          y: -3,
          boxShadow: '0 0 25px rgba(225, 6, 0, 0.35)'
        }} className="bg-gradient-to-br from-gray-900 to-gray-800 border border-motor-red/40 rounded-lg p-4 hover:border-motor-red transition-all duration-300 relative overflow-hidden" data-id="element-99">
              <div className="absolute top-0 left-0 bg-motor-red px-3 py-0.5" data-id="element-100">
                <span className="font-bebas text-white text-xs tracking-wider" data-id="element-101">
                  {item.tomo}
                </span>
              </div>

              <div className="flex items-center gap-4 pt-4" data-id="element-102">
                <div className="w-12 h-12 bg-motor-red/20 rounded-full flex items-center justify-center border border-motor-red flex-shrink-0" data-id="element-103">
                  <item.icon className="w-6 h-6 text-motor-red" data-id="element-104" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-105">
                  <h3 className="font-bebas text-lg text-white uppercase leading-tight" data-id="element-106">
                    {item.title}
                  </h3>
                  <p className="text-gray-500 font-montserrat text-xs mt-0.5" data-id="element-107">
                    {item.description}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-108">
                  <span className="font-montserrat text-gray-600 line-through text-xs block" data-id="element-109">
                    {item.price}
                  </span>
                  <span className="font-bebas text-motor-red text-sm" data-id="element-110">
                    INCLUIDO
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Bonuses */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-111">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-112">
            <Gift className="w-8 h-8 text-green-500" data-id="element-113" />
            <h3 className="font-bebas text-4xl sm:text-5xl text-white uppercase" data-id="element-114">
              🎁 BONOS GRATUITOS
            </h3>
          </div>
          <p className="text-base text-gray-400 font-montserrat" data-id="element-115">
            Incluidos <span className="text-green-400 font-bold" data-id="element-116">GRATIS</span>{' '}
            con tu compra • Valor:{' '}
            <span className="text-green-400 font-bold line-through" data-id="element-117">
              $9.990
            </span>
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-4" data-id="element-118">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} whileHover={{
          scale: 1.03
        }} className="bg-gradient-to-br from-gray-800 to-gray-900 border border-green-500/40 rounded-lg p-4 hover:border-green-500 transition-all duration-300 relative overflow-hidden" data-id="element-119">
              <div className="absolute top-0 right-0 bg-green-500 px-3 py-0.5" data-id="element-120">
                <span className="font-bebas text-motor-black text-xs tracking-wider" data-id="element-121">
                  GRATIS
                </span>
              </div>

              <div className="flex items-center gap-4 pt-2" data-id="element-122">
                <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border border-green-500 flex-shrink-0" data-id="element-123">
                  <bonus.icon className="w-6 h-6 text-green-500" data-id="element-124" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-125">
                  <h3 className="font-bebas text-lg text-white uppercase leading-tight" data-id="element-126">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-500 font-montserrat text-xs mt-0.5" data-id="element-127">
                    {bonus.description}
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-128">
                  <span className="font-montserrat text-gray-600 line-through text-xs block" data-id="element-129">
                    {bonus.price}
                  </span>
                  <span className="font-bebas text-green-400 text-sm" data-id="element-130">$0</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total value summary */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="text-center mt-8" data-id="element-131">
          <span className="inline-block bg-motor-red/10 border border-motor-red/40 rounded-full px-6 py-2 font-montserrat text-gray-300 text-sm" data-id="element-132">
            Valor total:{' '}
            <span className="text-white font-bold line-through" data-id="element-133">$49.990</span> →
            Hoy todo por solo{' '}
            <span className="text-motor-red font-bold text-lg" data-id="element-134">$19.990</span>
          </span>
        </motion.div>
      </div>
    </section>;
}